import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import { IconSelectionProvider } from './src/context/IconSelectionContext';
import { customComponents } from './src/customComponents';

export const wrapRootElement = ({ element }) => (
  <IconSelectionProvider>
    <CustomComponentsProvider list={customComponents}>{element}</CustomComponentsProvider>
  </IconSelectionProvider>
);
